// 请求接口地址 如果没有配置自动获取当前网址路径
// const VUE_APP_API_URL = process.env.VUE_APP_BASE_API || `${location.origin}`
// http://192.168.2.176:80
// http://47.101.181.199:801
// http://47.103.97.137:801
// https://www.imka.cn/apis
const VUE_APP_API_URL = process.env.VUE_APP_BASE_API || 'https://www.coopwin.com/apis'

const VUE_APP_WS_URL = process.env.VUE_APP_WS_URL || (location.protocol === 'https' ? 'wss' : 'ws') + ':' + location
  .hostname
const SettingMer = {
  // 服务器地址
  httpUrl: VUE_APP_API_URL,
  // 接口请求地址
  apiBaseURL: VUE_APP_API_URL + '/api/',
  // socket连接
  wsSocketUrl: VUE_APP_WS_URL
}

export default SettingMer



// WEBPACK FOOTER //
// ./src/utils/settingMer.js